import React, { useRef, useState } from "react";
import { Box, Typography } from "@mui/material";

const PRIMARY = "#FF5E00BF";

const ExcelBody = ({ selectedFile, setSelectedFile }) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleFile = (file: File) => {
    if (!file.name.endsWith(".xlsx") && !file.name.endsWith(".xls")) {
      return;
    }
    setSelectedFile(file);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    if (e.dataTransfer.files[0]) handleFile(e.dataTransfer.files[0]);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files?.[0]) handleFile(e.target.files[0]);
  };

  return (
    <Box>
      <input
        ref={fileInputRef}
        type="file"
        accept=".xls,.xlsx"
        hidden
        onChange={handleChange}
      />

      <Box
        onClick={() => fileInputRef.current?.click()}
        onDragOver={(e) => e.preventDefault()}
        onDrop={handleDrop}
        sx={{
          border: `2px dashed ${PRIMARY}`,
          borderRadius: 2,
          p: 3,
          textAlign: "center",
          cursor: "pointer",
          "&:hover": { bgcolor: "rgba(255,94,0,0.05)" },
        }}
      >
        <Typography variant="body2">
          <b>Click to select</b> or drag & drop your <b>.xls/.xlsx</b> file here
        </Typography>

        {selectedFile && (
          <Typography mt={1} variant="body2" color="primary">
            Selected: {selectedFile.name}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default ExcelBody;
